export default "__VITE_ASSET__BiZRU1UK__"